import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import styles from "./ProductCompare.module.css";
import { get } from "../../utilities/apiClient";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import PartialBanner, { IPartialBanner } from "../../components/partialBanner/PartialBanner";
import { useLocation } from "react-router-dom";
import HeadingSection from "../../components/headingSection/HeadingSection";
import { Input } from "reactstrap";


const webImg = "https://sajkoaonline.blob.core.windows.net/jkoa/covers/About-us.jpg";
const mobImg = "https://sajkoaonline.blob.core.windows.net/jkoa/covers/About-us-page-mobile-version.jpg";
const banner: IPartialBanner = { bannerId: 1, bannerName: "Banner", webImageURL: webImg, mobileImageURL: mobImg }


function ProductCompare() {
    const search = useLocation().search;
    const [itemCode1, setItemCode1] = useState(new URLSearchParams(search).get('ic'));
    var searchingData1 = useSelector((state: RootState) => state.seachData);

    const responsive = useSelector((state: RootState) => state.responsive);
    const [itemCode2, setItemCode2] = useState("");
    const [isWeb, setIsWeb] = useState<boolean>(true);
    const [search1, setSearch1] = useState<any>();
    const [search2, setSearch2] = useState<any>();
    const [selectedItem1, setSelectedItem1] = useState<any>(undefined);
    const [selectedItem2, setSelectedItem2] = useState<any>(undefined);
    const [specItem1, setSpecItem1] = useState<any>();
    const [specItem2, setSpecItem2] = useState<any>();
    const [showSuggestions2, setShowSuggestions2] = useState([]);
    const [searchingData2, setSearchingData2] = useState<any>([]);
    const [showSearchBar2, setShowSearchBar2] = useState(true);
    const [showSuggestions1, setShowSuggestions1] = useState([]);
    const [showSearchBar1, setShowSearchBar1] = useState(true);

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
        if (itemCode1 != null || itemCode1 != undefined) {
            getPageData(true, itemCode1);
        }
    }, [])

    const searchingDataFn1 = (event: any) => {
        setSearch1(event.target.value);
        if (event.target.value.length >= 1) {
            var result = searchingData1.products.sort().filter((product: any) => product.itemName.toUpperCase().includes(event.target.value.toUpperCase()))
            setShowSuggestions1(result);
        }
        else {
            setShowSuggestions1([]);
        }
    };
    const searchingDataFn2 = (event: any) => {
        setSearch2(event.target.value);
        if (event.target.value.length >= 1) {
            debugger
            var result = searchingData2.sort().filter((product: any) => product.itemName.toUpperCase().includes(event.target.value.toUpperCase()))
            setShowSuggestions2(result);
        }
        else {
            setShowSuggestions2([]);
        }
    };

    const itemSelect1 = (itemCode: string) => {
        setItemCode1(itemCode);
        setShowSearchBar1(false);
        getPageData(true, itemCode);
    }

    const itemSelect2 = (itemCode: string) => {
        setItemCode2(itemCode);
        setShowSearchBar2(false);
        getPageData(false, itemCode);
    }

    function getPageData(initialItem: boolean, ic: any) {
        get("WebModule/GetItemCompareData", { itemCode: ic }, false)
            .then(res => {
                var response: any = res;
                if (response.data.statusCode === 200) {
                    if (response.data.result.itemMaster == null) {
                        window.location.href = "/home";
                    }
                    else {
                        if (initialItem) {
                            setSelectedItem1(response.data.result.itemMaster);
                            setSpecItem1(response.data.result.itemSpecifications);
                            setSearch1(response.data.result.itemMaster.itemName);
                            setSearchingData2(response.data.result.itemSearches)
                        }
                        else {
                            setSelectedItem2(response.data.result.itemMaster);
                            setSpecItem2(response.data.result.itemSpecifications);
                            setSearch2(response.data.result.itemMaster.itemName);
                        }
                    }
                }
            });
    }

    function resetSearch2() {
        setItemCode2("")
        setSelectedItem2(undefined);
        setSpecItem2(undefined);
        setSearch2("");
    }
    function resetSearch1() {
        if (itemCode2 != "") {
            window.location.href = "/productCompare?ic=" + itemCode2
        }
        else {
            setItemCode1(null);
            setSelectedItem1(undefined);
            setSpecItem1(undefined);
            setSearch1("");
            setSearchingData2(undefined);
        }
    }

    function getDescription(aa: any) {
        var result = specItem2.filter((a: any) => a.specificationId === aa);
        if (result.length > 0) {
            return result[0].description;
        }
        else return []

    }
    function price(val: number) {
        var value = (Math.round(val * 100) / 100).toFixed(2);
        return "Rs. " + String(value).replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,');
    }

    return (
        <React.Fragment>
            <div className={`container`}>
                <Container>
                    <div>
                        <HeadingSection
                            subHeading={null}
                            mainHeading="Product comparison"
                            content={null}
                        />
                    </div>
                </Container>
            </div>
            <Row className={`${styles.filterContainer}`} style={{ margin: "0", padding: "0" }}>
                <Col lg="6" md="6" xs="6" >
                    <Row>
                        <Col lg="5" md="12" xs="12" />
                        <Col style={{ paddingTop: "1rem" }}>
                            <div className={`${styles.compareText}`}>COMPARE WITH</div>
                            <Row style={{ marginBottom: "1rem" }}>
                                <Col lg="7" md="12" xs="12">
                                    <Input type="search" name="itemName1" id="itemName1" autoComplete="off" className={`${styles.searchBox}`}
                                        value={search1} onChange={searchingDataFn1} onClick={() => setShowSearchBar1(true)}
                                        disabled={selectedItem1 != undefined} />
                                    <div className={`${styles.searchContainer} ${styles.fade}`} hidden={!showSearchBar1 || itemCode1 != null}>
                                        {
                                            showSuggestions1.map((item: any) => {
                                                return (
                                                    <div className={`${styles.searchResult}`}
                                                        onClick={() => { itemSelect1(item.itemCode); setShowSearchBar1(false) }}>
                                                        {item.itemName}
                                                    </div>
                                                )
                                            }
                                            )
                                        }
                                    </div>
                                </Col>
                                <Col>
                                    <Button className={`${styles.clearbtn}`}
                                        onClick={() => resetSearch1()}> Clear
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col lg="6" md="6" xs="6" >
                    <Row>
                        <Col style={{ paddingTop: "1rem" }}>
                            <div className={`${styles.compareText}`}>COMPARE WITH</div>
                            <Row style={{ marginBottom: "1rem" }}>
                                <Col lg="7" md="12" xs="12">
                                    <Input disabled={itemCode1 == null || selectedItem2 != undefined} type="search" name="itemName2" id="itemName2" autoComplete="off" className={`${styles.searchBox}`}
                                        value={search2} onChange={searchingDataFn2} onClick={(e: any) => { searchingDataFn2(e); setShowSearchBar2(true) }} />
                                    <div className={`${styles.searchContainer} ${styles.fade}`} hidden={!showSearchBar2}>
                                        {
                                            showSuggestions2.map((item: any) => {
                                                return (
                                                    <div className={`${styles.searchResult}`}
                                                        onClick={() => itemSelect2(item.itemCode)}>
                                                        {item.itemName}
                                                    </div>
                                                )
                                            }
                                            )
                                        }
                                    </div>
                                </Col>
                                <Col>
                                    <Button className={`${styles.clearbtn}`} onClick={() => resetSearch2()}> Clear
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg="5" md="12" xs="12" />
                    </Row>
                </Col>
            </Row>
            <Row style={{ margin: "0", padding: "0" }}>
                <Table bordered className={`${styles.tableContainer}`}>
                    <tbody>
                        <tr className={`${styles.mainText}`} style={{ borderWidth: "0 " }}>
                            <th style={{ textAlign: "right", borderBottom: "1px", width: "50%", paddingTop: "3rem" }}>
                                <Row>
                                    <Col style={{ margin: " 0 2rem 0 0.5rem" }}>
                                        <div>{selectedItem1 != undefined ? selectedItem1.itemName : ""}</div>
                                    </Col>
                                </Row>
                            </th>
                            <th style={{ borderBottom: "1px", width: "50%", paddingTop: "3rem" }}>
                                <Row>
                                    <Col style={{ margin: " 0 0.5rem 0 2rem" }}>
                                        <div>{selectedItem2 != undefined ? selectedItem2.itemName : ""}</div>
                                    </Col>
                                </Row>
                            </th>
                        </tr>
                        <tr className={`${styles.mainText}`} style={{ borderWidth: "0 " }}>
                            <th style={{ textAlign: "right" }}>
                                <Row>
                                    <Col style={{ margin: " 0 2rem 0 0.5rem" }}>
                                        {selectedItem1 != undefined ?
                                            <div>{selectedItem1.unitPrice != 0 ? price(selectedItem1.unitPrice) : ""}</div>
                                            : null}
                                    </Col>
                                </Row>
                            </th>
                            <th>
                                <Row>
                                    <Col style={{ margin: " 0 0.5rem 0 2rem" }}>
                                        {selectedItem2 != undefined ?
                                            <div>{selectedItem2.unitPrice != 0 ? price(selectedItem2.unitPrice) : ""}</div>
                                            : null}
                                    </Col>
                                </Row>
                            </th>
                        </tr>
                        <tr style={{ borderWidth: "0" }}>
                            <td style={{ textAlign: "right" }}>
                                {selectedItem1 != undefined ?
                                    <img style={{ width: isWeb ? "50%" : "100%" }}
                                        src={selectedItem1.assetURL}></img>
                                    : null}
                            </td>
                            <td style={{ textAlign: "left" }}>
                                {selectedItem2 != undefined ?
                                    <img style={{ width: isWeb ? "50%" : "100%" }}
                                        src={selectedItem2.assetURL}></img>
                                    : null}
                            </td>
                        </tr>
                        {specItem1 != undefined ?
                            specItem1.map((spec: any, index: number) => {
                                return (
                                    <tr id={spec.specificationId}>
                                        <td>
                                            <Row style={{ padding: "2rem" }} >
                                                <Col lg="5" md="12" xs="12">
                                                    <div className={`${styles.specProperty}`}>{spec.property}</div>
                                                </Col>
                                                <Col>
                                                    <div className={`${styles.specDescription}`}>
                                                        {spec.description.map((des: any) => {
                                                            return (
                                                                <span>{des} <br /></span>
                                                            )
                                                        })
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </td>
                                        {specItem2 != undefined ?
                                            <td>
                                                <Row style={{ padding: "2rem" }} >
                                                    <Col lg="5" md="12" xs="12">
                                                        <div className={`${styles.specProperty}`}>{spec.property}</div>
                                                    </Col>
                                                    <Col>
                                                        <div className={`${styles.specDescription}`}>
                                                            {
                                                                getDescription(spec.specificationId).map((des: any) => {
                                                                    return (
                                                                        <span>{des} <br /></span>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </td>
                                            : null}
                                    </tr>
                                )
                            })
                            : null}
                        {specItem2 != undefined ?
                            specItem2.map((spec: any, index: number) => {
                                return (
                                    <tr id={spec.specificationId}>
                                        {specItem1.filter((a: any) => a.specificationId == spec.specificationId).length > 0 ?
                                            null :
                                            <>
                                                <td>
                                                    <Row style={{ padding: "2rem" }} >
                                                        <Col lg="5" md="12" xs="12">
                                                            <div className={`${styles.specProperty}`}>{spec.property}</div>
                                                        </Col>
                                                    </Row>
                                                </td>
                                                <td>
                                                    <Row style={{ padding: "2rem" }} >
                                                        <Col lg="5" md="12" xs="12">
                                                            <div className={`${styles.specProperty}`}>{spec.property}</div>
                                                        </Col>
                                                        <Col>
                                                            <div className={`${styles.specDescription}`}>
                                                                {spec.description.map((des: any) => {
                                                                    return (
                                                                        <span>{des} <br /></span>
                                                                    )
                                                                })
                                                                }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </td>
                                            </>
                                        }
                                    </tr>
                                )
                            })
                            : null}
                    </tbody>
                </Table>
            </Row>

            <div className={`container`}>
                <Container>

                </Container>
            </div>
        </React.Fragment >
    )
}

export default ProductCompare;